import logoUrl from '../assets/efax-logo.png'

/**
 * Official eFax wordmark, bundled into the image at build time.
 *
 * The asset is a transparent-background RGBA PNG (640x202, downscaled from the
 * 1568x496 original) of the gradient wordmark (blue -> purple -> red). Every
 * gradient stop is bright and saturated, so it reads clearly on the dark header
 * without any recolouring — do NOT apply a filter or tint to it.
 *
 * Bundled deliberately rather than hot-linked: no remote reference at runtime.
 */
const ASPECT_RATIO = 640 / 202

export function EfaxWordmark({ height = 32 }: { height?: number }) {
  return (
    <img
      src={logoUrl}
      alt="eFax"
      height={height}
      width={Math.round(height * ASPECT_RATIO)}
      style={{
        height,
        width: 'auto',
        display: 'block',
        userSelect: 'none',
      }}
      draggable={false}
    />
  )
}

export default EfaxWordmark
